<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
        <img src="@/assets/logo.svg" alt="">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
import LogoSvg from '@/assets/logo2.png'

export default {
  name: 'Logo',
  props: {
    title: {
      type: String,
      default: '后台管理',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
